var React = require('react');

function Credit (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"credit card10"),React.createElement("g",{"data-name":"Layer 2","key":1},React.createElement("path",{"d":"M85.71,13.59H10.29A7.29,7.29,0,0,0,3,20.88V75.12a7.29,7.29,0,0,0,7.29,7.29H85.71A7.29,7.29,0,0,0,93,75.12V20.88A7.29,7.29,0,0,0,85.71,13.59ZM10.29,18.1H85.71a2.79,2.79,0,0,1,2.78,2.78v7.43h-81V20.88A2.79,2.79,0,0,1,10.29,18.1ZM85.71,77.9H10.29a2.79,2.79,0,0,1-2.78-2.78V42h81V75.12A2.79,2.79,0,0,1,85.71,77.9ZM49,53.13H15.88a2,2,0,0,1,0-4H49a2,2,0,0,1,0,4Zm-16.56,9H15.88a2,2,0,0,1,0-4H32.44a2,2,0,0,1,0,4Z","transform":"translate(-3 -13.59)"}))]);
}

Credit.defaultProps = {"viewBox":"0 0 90 86.02499999999999","x":"0px","y":"0px"};

module.exports = Credit;

Credit.default = Credit;
